export function graderAblyChannelName(id: string | null) {
	return id ? id : "";
}

export function visionAblyChannelName(id: string | null) {
	return id ? `vision:${id}` : "";
}
